/**
 * Fisher-Yates shuffle — returns a new shuffled copy of the array
 * @param {Array} array - The array to shuffle
 * @returns {Array} A new shuffled array
 */
export const shuffle = array => {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};
